/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Reset_To_DefaultInputs */

const en_common_reset_to_default = /** @type {(inputs: Common_Reset_To_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset to default`)
};

const es_common_reset_to_default = /** @type {(inputs: Common_Reset_To_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restablecer`)
};

/**
* | output |
* | --- |
* | "Reset to default" |
*
* @param {Common_Reset_To_DefaultInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_reset_to_default = /** @type {((inputs?: Common_Reset_To_DefaultInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Reset_To_DefaultInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_reset_to_default(inputs)
	return en_common_reset_to_default(inputs)
});